import React from 'react';
import PropTypes from 'prop-types';

const ToggleButton = ({
  id,
  onClassName,
  offClassName,
  textLabel,
  type,
  style,
  value,
  setValue,
}) => (
  <button
    type={type === 'button' ? 'button' : 'submit'}
    id={id}
    className={value ? onClassName : offClassName}
    style={style}
    onClick={() => setValue(!value)}
  >
    {textLabel}
  </button>
);

ToggleButton.propTypes = {
  id: PropTypes.string,
  onClassName: PropTypes.string,
  offClassName: PropTypes.string,
  textLabel: PropTypes.string,
  type: PropTypes.string,
  style: PropTypes.objectOf(PropTypes.string),
  value: PropTypes.bool,
  setValue: PropTypes.func,
};

ToggleButton.defaultProps = {
  id: 'button',
  onClassName: 'primary-button',
  offClassName: 'secondary-button',
  textLabel: '',
  type: 'button',
  style: {},
  value: false,
  setValue: () => {},
};

export default ToggleButton;
